export default __webpack_public_path__ + "static/Living-in-STL_4-ab5fce909b1666e966f048f0d6aa52f7.jpg";